import React from 'react'

export const ChartLine = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='25'
    height='24'
    viewBox='0 0 25 24'
    {...props}
  >
    <g clip-path='url(#clip0_2875_63544)'>
      <path
        d='M3.5 4C4.01283 4 4.43551 4.38604 4.49327 4.88338L4.5 5V19H21.5C22.0523 19 22.5 19.4477 22.5 20C22.5 20.5128 22.114 20.9355 21.6166 20.9933L21.5 21H3.5C2.98717 21 2.56449 20.614 2.50673 20.1166L2.5 20L2.5 5C2.5 4.44772 2.94772 4 3.5 4Z'
      />
      <circle cx='18' cy='7.5' r='2.5' />
      <circle cx='8' cy='14.5' r='2.5' />
      <path
        d='M19.4998 7.49951C19.9951 6.74827 19.3349 5.77322 18.4535 5.95422C18.0171 6.04384 17.7206 6.49873 16.8137 8.03062L14.2896 11.8593L11.0335 9.71266C10.5263 9.37827 9.84407 9.51836 9.50966 10.0256L7.00022 13.7115C6.69624 14.1726 6.82361 14.7928 7.2847 15.0968C7.7458 15.4007 8.36602 15.2734 8.67001 14.8123L10.6841 11.8779L13.9401 14.0244C14.4474 14.3588 15.1296 14.2187 15.464 13.7115L19.4998 7.49951Z'
      />
    </g>
    <defs>
      <clipPath id='clip0_2875_63544'>
        <rect width='24' height='24' fill='white' transform='translate(0.5)' />
      </clipPath>
    </defs>
  </svg>
)
